<template>
    <v-row>
      <v-dialog v-model="showDialog" scrollable max-width="90%" style="z-index: 1009;">
        <v-skeleton-loader
        v-if="loading"
          type="article, actions"
        ></v-skeleton-loader>
        <v-card v-show="!loading">
          <v-card-title>
            <v-panel>
                <span style="font-size: 20px;">
                    {{ dialog ? st(dialog.title) : '' }}
                </span>
            </v-panel>
          </v-card-title>
          <v-card-text>
            <iframe ref='builder' frameBorder="0" width='100%' height='650' :src="'form-viewer.html?callbackId='+callbackId"/>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
          <v-btn v-if="showDeleteButton" color="#ff0000" @click="isInUse()">
						<v-icon left color="#ffffff">delete</v-icon>
						<span style="color: #ffffff;">{{ $t('wkt.admin.common.dialog-buttons.delete').toUpperCase() }}</span>
					</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#124D91" v-if="showSaveButton" text @click="saveItem()">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
          <v-btn text @click="showDialog=false">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
        </v-card-actions>
        </v-card>

        <ConfirmDialog ref="dlgConfirm"
              v-bind:title="$t('wkt.admin.common.delete.confirm-dialog.title')"
              v-bind:message="$t('wkt.admin.common.delete.confirm-dialog.text')"
              v-bind:titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
              v-bind:titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
              v-on:confirmed="deleteItem()"
          />

      </v-dialog>
  
    </v-row>	
  </template>
  
<script>

import BaseModule from '../../common/BaseModule.js'
import api from '../../../api/worktime'
import gwt from '../../../api/gwt'
import ConfirmDialog from '../../common/ConfirmDialog'
import discovery from '../../../discovery';

export default {
   name: 'DBDialog',
   mixins: [BaseModule],
   components: {
      ConfirmDialog
   },
   data() {
      return {
         showDialog: false,
         loading: true,
         action: null,
         isReady: false,
         form: null,
         formDefinition: null,
         submission: null,
         callbackId: 'form-viewer-'+(new Date().getTime()),
         dialog: null,
         showDeleteButton: false,
         showSaveButton: false,
         writeAccessAllowed: false
      }
   },
   methods: {
      parseEndpoint(endpoint)
      { 
          return endpoint.replace("{id}",this.payload);
      },
      isInUse() { 
        // EXPENSE_SHEET_CATEGORY
        if (this.getModuleId(this.dialog.id) === 27) {
          api.getExpensesCountByExpenseCategoryId(this.submission.data.id, res => {
            if (res > 0) {
              const message = this.$t('wkt.admin.expensesheetcategory.edit-window.associated_request_error', [res]);
              this.$emit('show-alert',{ text: message, color: 'error', timeout: 3000 });
              return;
            }
              
            this.confirmDelete();
          },
          error=> {
              console.log(error);
          }); 
          return;
        }

        this.confirmDelete();        
      },
      confirmDelete() {
         this.$refs.dlgConfirm.confirm(this.submission);
      },
      deleteItem() {
        this.loading = true;
          const vm = this;
          api.dialogBuilderDELETE(
            vm.parseEndpoint(vm.dialog.deleteEndpoint),
            res => {
              this.loading = false;
              this.showDialog = false;
              console.log(res);
                vm.$emit('refresh');
            },
            error => {
                this.loading = false;
                this.$log.error(error);
            });
      },
      saveItem() {
        this.$refs.builder.contentWindow.postMessage({ action: 'submit'});
      },
      doSaveItem() {
        this.loading = true;
          const vm = this;
          api.dialogBuilderPOST(
            vm.parseEndpoint(vm.dialog.postEndpoint), 
            vm.submission.data,
            res => {
              if (res && res.message && res.rsOK===false)
              {
                vm.$emit('show-alert',{ text: res.message, color: 'error', timeout: 3000 });
                this.loading = false;
              }
              else
              {
                vm.$emit('refresh');
                this.showDialog = false;
              }
              
            },
            error => {
                this.loading = false;
                this.$log.error(error);
                vm.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            });
      },
      processForm() {
            
        const vm = this;
        vm.showDeleteButton = vm.writeAccessAllowed && !!vm.dialog.deleteEndpoint;
        vm.showSaveButton = vm.writeAccessAllowed && (!!vm.dialog.putEndpoint || !!vm.dialog.postEndpoint);
        
        if (vm.action == 'CREATE' || !vm.dialog.getEndpoint) 
        {
          vm.submission = { data: {}};
          vm.loading = false;
          vm.sendFormData();
          return;
        }

        api.dialogBuilderGET(vm.parseEndpoint(vm.dialog.getEndpoint),
            res=>{
                vm.submission = { data: res};
                vm.loading = false;
                vm.sendFormData();
            }, 
            error => {
                vm.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
                vm.loading = false;
            });

        
      },
      replaceClasses(component) {
        const classesToReplace = ['row'];
        for (let item of classesToReplace) {
          if (component.element.classList.contains(item)) {
            component.element.classList.remove(item);
            component.element.classList.add('formio-'+item);
          }
        }
      },
      sendFormData() {
          if (!this.submission || !this.formDefinition || !this.isReady)
          {
            return;
          }

          let messages = this.$i18n.messages[this.$i18n.locale];

          if (!messages) 
          {
            messages = this.$i18n.messages[this.$i18n.fallbackLocale];
          }

          this.$refs.builder.contentWindow.postMessage({  
                      'type': 'ready',
                      'definition': this.formDefinition ? api.encodeBase64(this.formDefinition) : '{}', 
                      'lastSubmission': this.submission ? api.encodeBase64(JSON.stringify(this.submission)) : '{}', 
                      'role':'DIALOG_BUILDER',
                      'protected': false,
                      'sessionInfo':JSON.stringify(gwt.getSessionInformation()),
                      'messages': this.$i18n.messages[this.$i18n.locale],
                      'locale': this.$i18n.locale,
                      'service': {
                            baseUrl: discovery.worktime_service_url,
                            headers: api.getCommonHeaders().headers
                        }
                  });
      },
      onWheel(event) {
            event.stopPropagation()
        },
        processMessage(msg) {
          if (!msg.data) return;

          if (!msg.data.target || msg.data.target!=this.callbackId) return;

          if (msg.data.type==='ready') {
              this.isReady=true;
              this.sendFormData();
          }

          if (msg.data.type==='submit') {
              this.submission=msg.data.payload;
              this.doSaveItem();
          }
        },
      // eslint-disable-next-line no-unused-vars
      open: function (action, payload, eventConfig) {

         this.showDialog = true;
         this.formDefinition = null;
         this.submission = null;
         this.writeAccessAllowed = false;
         
         if (!payload && action != 'CREATE') { 
            this.loading = false; 
            this.showDialog = false;
            return;
         }
         
         this.payload = payload;
         this.action = action;

         this.loading = true;

        let profile = gwt.getSessionProfile();
        let sessionInformation = gwt.getSessionInformation();
        let isSuperAdmin = sessionInformation?sessionInformation.employee.isSuperAdmin:false;

         const vm = this;
         api.getDialog(eventConfig.dialogId, res => {
            vm.dialog = res;
            vm.formDefinition = vm.dialog.formDefinition;

                
            //revisamos permisos
            let readAccessAllowed = (isSuperAdmin || !vm.dialog.readRolesAllowed || this.matchRole(profile,vm.dialog.readRolesAllowed.split(',')));
         
            if (!readAccessAllowed)
            { 
                vm.loading = false; 
                vm.showDialog = false;
                return;
            }
            
            vm.writeAccessAllowed = (!vm.dialog.writeRolesAllowed || this.matchRoleModify(profile,vm.dialog.writeRolesAllowed.split(',')));
           
            //comprobamos tipo de licencia
            if (vm.writeAccessAllowed) {
              vm.writeAccessAllowed = vm.checkLicenseTypeByModule(vm.getModuleId(eventConfig.dialogId), sessionInformation.company.licenseType) === '';
            }
            
            vm.processForm();
         },
         error=> {
            console.log(error);
         });         
      },
      getModuleId(dialogId) {
        switch (parseInt(dialogId)) {
          case 6: return 27; // EXPENSE_SHEET_CATEGORY
        }
      },
   },
   mounted: function ()  {
         if (window.addEventListener) {
                window.addEventListener("message", this.processMessage, false);
            }
            else {
                window.attachEvent("onmessage", this.processMessage);
            }
      
  },
}
</script>